import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { ClientLogos } from '../components/ClientLogos';
import { About } from '../components/About';
import { ImpactNumbers } from '../components/ImpactNumbers';
import { Specialties } from '../components/Specialties';
import { WhyForax } from '../components/WhyForax';
import { ProjectsGallery } from '../components/ProjectsGallery';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-blue-600 selection:text-white" data-id="element-419">
      <Header data-id="element-420" />

      <div id="home" data-id="element-421">
        <Hero data-id="element-422" />
      </div>

      <ClientLogos data-id="element-423" />

      <div id="about" data-id="element-424">
        <About data-id="element-425" />
      </div>

      <ImpactNumbers data-id="element-426" />

      <Specialties data-id="element-427" />
      <WhyForax data-id="element-428" />

      <div id="projects" data-id="element-429">
        <ProjectsGallery data-id="element-430" />
      </div>

      <div id="contact" data-id="element-431">
        <FinalCTA data-id="element-432" />
      </div>

      <Footer data-id="element-433" />
    </main>;
}